@if (showCABanner$ | async) {
  <div
    (click)="startCustodyAccountOpening(custodyAccountOpening)"
    class="ca-banner-container flex justify-between card items-center">
    <div class="flex justify-start ca-banner-text">
      <div class="ca-banner-title">
        {{ "custody_account_opening_banner_title" | translate }}
      </div>
      <div class="ca-banner-description">
        {{ "custody_account_opening_banner_description" | translate }}
      </div>
    </div>
    <div class="ca-banner-image flex flex-no-shrink"> </div>
  </div>
}
<router-outlet name="custody-account"></router-outlet>
